import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "core-js/modules/es.array.concat.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { keyframes } from '@emotion/react';
import { commonStyles } from '../styles';
export var rippleBaseStyles = function rippleBaseStyles(props) {
  return function (theme) {
    var backColor = props.backColor,
        focusColor = props.focusColor;
    return [{
      position: 'relative',
      overflow: 'hidden',
      outline: 'none',
      userSelect: 'none',
      '&:before': {
        content: focusColor ? "''" : 'none',
        display: 'block',
        opacity: '0',
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: 10,
        transition: 'all 300ms'
      },
      '&:after': {
        content: "''",
        display: 'block',
        opacity: '0',
        position: 'absolute',
        borderRadius: '50%',
        backgroundColor: backColor ? theme[backColor] : theme.primaryDark,
        pointerEvents: 'none',
        transform: 'scale(0)',
        transformOrigin: 'center center',
        zIndex: 20
      }
    }].concat(_toConsumableArray(commonStyles(props)));
  };
};
export var onFocus = function onFocus(color) {
  return function (theme) {
    return {
      '&:before': {
        backgroundColor: color ? theme[color] : theme.primaryDark,
        opacity: '1'
      }
    };
  };
};
var radiusIn = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    animation-timing-function: linear;\n    transform: scale(0);\n  }\n\n  to {\n    transform: scale(2.5);\n  }\n"])));
var opacityIn = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    animation-timing-function: linear;\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
export var animationOn = function animationOn(left, top, size) {
  return {
    '&:after': {
      width: size,
      height: size,
      left: left,
      top: top,
      animation: "".concat(radiusIn, " 300ms forwards, ").concat(opacityIn, " 100ms forwards")
    }
  };
};